import axios from "axios";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


// 관리자 목록 가져오기
export const deleteUser = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/qna-user`, data);
  return response.data;
};

// 문의사항 등록 요청
export const sendQuestion = async (text) => {
  const response = await axios.post(`${API_BASE_URL}/qna`, { text });
  return response.data;
};